import script from "./RegionHeatmap.vue?vue&type=script&setup=true&lang=js"
export * from "./RegionHeatmap.vue?vue&type=script&setup=true&lang=js"

import "./RegionHeatmap.vue?vue&type=style&index=0&id=17eaf2a8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17eaf2a8"]])

export default __exports__